import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { ComponentType, IconName, Button } from '@gcl/react-core';
import './ButtonNavBar.scss';
import { useProjectIsArchived } from '@config/config.hooks';

export interface IButtonNavBarItem {
  iconName?: IconName;
  componentType?: ComponentType;
  text?: string;
  onClick?: (e: React.MouseEvent | undefined) => void;
  navigateToPath?: string;
  component?: React.ReactNode;
  showNoneInArchivedProject?: boolean;
}

export interface IButtonNavBarProps {
  items: IButtonNavBarItem[];
  className?: string;
  rightItems?: IButtonNavBarItem[];
}

export const ButtonNavBar: React.FunctionComponent<IButtonNavBarProps> = ({
  items,
  rightItems = [],
  className = '',
}) => {
  const isProjectArchived = useProjectIsArchived();

  const navigate = useNavigate();

  const createButton = React.useCallback(
    (item: IButtonNavBarItem, index: number) => {
      if ((item.showNoneInArchivedProject ?? false) && isProjectArchived) return <></>;
      if (item.component)
        return (
          <div key={`${item.text || ''}-${index}`} className="gcl-mr-sm">
            {item.component}
          </div>
        );

      return (
        <Button
          key={`${item.text}-${index}`}
          type={item.componentType}
          prefixIconName={item.iconName}
          className="gcl-mr-sm"
          onClick={
            item.navigateToPath
              ? () => {
                  navigate(item.navigateToPath || '');
                }
              : item.onClick
          }
        >
          {item.text}
        </Button>
      );
    },
    [isProjectArchived],
  );

  return (
    <div className={`gcl-gems-button-nav-bar-container ${className}`}>
      <div className="gcl-gems-button-nav-bar-container-button-bar">
        {items.map((item, index) => createButton(item, index))}
      </div>
      <div className="gcl-gems-button-nav-bar-container-button-bar">
        {rightItems.map((item, index) => createButton(item, index))}
      </div>
    </div>
  );
};
